import type { EnterpriseCardInput } from '../reports/enterprise/enterpriseReportModel';
import { buildTechnicalFlowReport } from '../reports/technical/technicalFlowReport';
import { renderTechnicalFlowPdf, type FlowMapImage } from '../reports/technical/technicalFlowReportPdf';
import { captureFlowCanvas } from './exportEnterpriseReport';

interface ProjectData {
  name: string;
  organizationName?: string | null;
  futureCards?: EnterpriseCardInput[] | null;
  viewMode?: 'current_clean' | 'kaizen_work' | 'future_simulated';
}

export const exportTechnicalFlowReport = async (
  canvasElement: HTMLElement,
  project: ProjectData,
  cards: EnterpriseCardInput[],
): Promise<void> => {
  const model = buildTechnicalFlowReport({
    processName: project.name,
    organizationName: project.organizationName,
    cards,
    futureCards: project.futureCards,
  });

  let image: FlowMapImage | null = null;
  try {
    image = await captureFlowCanvas(canvasElement);
  } catch (error) {
    console.warn('[technical-flow-report] Mapa não capturado.', error);
  }

  const maps = {
    current: project.viewMode === 'current_clean' ? image : null,
    future: project.viewMode === 'future_simulated' ? image : null,
  };
  await renderTechnicalFlowPdf(model, maps);
};
